export default __webpack_public_path__ + "static/media/Jogo-Do-Bicho-3-2.03d965f5.png";